<app-system-page-layout>
  <ng-container content>
    <mat-card style="padding: 30px;">
      <app-group-user-list></app-group-user-list>
    </mat-card>
  </ng-container>
</app-system-page-layout>
